/**
 * 10F 模拟数据（接真实接口后仅开发环境使用，按 addressId 请求线上数据）
 */

export const MOCK_ADDRESS = {
  id: '2052371980890431490',
  name: '10F',
  display: '10F'
}

export const MOCK_PLACEMENTS = [
  { id: '2053660201989464066', deviceId: '2051888177138917377', config: '{"data":{"text":"10楼东大字","x":361.0597766473713,"y":545.7259204939708}}' },
  { id: '2053660494902878209', deviceId: '2051889474768494593', config: '{"data":{"text":"南过道","x":659.6442787748892,"y":717.851253928387}}' },
  { id: '2053660558975066114', deviceId: '2051889474768494594', config: '{"data":{"text":"北过道＋小过道","x":647.9865113965368,"y":361.32975237800315}}' },
  { id: '2053664024598437889', deviceId: '2051889474768494594', config: '{"data":{"text":"北过道＋小过道","x":1070.929431431162,"y":532.8073400547324}}' },
  { id: '2053717758871363587', deviceId: '2051889474760105986', config: '{"data":{"text":"10东电梯厅灯带","x":863.2356480422645,"y":512.5837266313135}}' },
  { id: '2054019649857675266', deviceId: '2054007940510146572', config: '{"data":{"text":"1007房间办公区间隔灯","x":163.16683482792092,"y":952.7063853383077}}' },
  { id: '2054019697748238338', deviceId: '2054007940510146573', config: '{"data":{"text":"1007房间办公区间隔灯","x":162.66683482792098,"y":856.4196770138728}}' },
  { id: '2054019898277912577', deviceId: '2054007940510146575', config: '{"data":{"text":"1006-1","x":422.74775068830127,"y":816.8104115090207}}' },
  { id: '2054020011322793986', deviceId: '2054007940510146574', config: '{"data":{"text":"1007房间公司牌灯","x":254.79990416617613,"y":855.9196770138728}}' },
  { id: '2054020214171918337', deviceId: '2054007940510146568', config: '{"data":{"text":"105B-1","x":675.1756315334272,"y":818.4450871562568}}' },
  { id: '2054020225618173953', deviceId: '2054007940510146569', config: '{"data":{"text":"105B-2","x":674.6756315334271,"y":890.6355924638995}}' },
  { id: '2054020231737663490', deviceId: '2054007940510146570', config: '{"data":{"text":"105B-3","x":674.1756315334271,"y":963.6328487631829}}' },
  { id: '2054020418312888321', deviceId: '2054007940510146567', config: '{"data":{"text":"公共空间墙侧筒灯","x":1187.621945142371,"y":459.4529477546953}}' },
  { id: '2054020490014515201', deviceId: '2054007940510146566', config: '{"data":{"text":"公共空间长条灯","x":1187.121945142371,"y":519.5382188577938}}' },
  { id: '2054020644952104961', deviceId: '2054007940493369345', config: '{"data":{"text":"1013房间墙侧间隔筒灯","x":1255.140909017406,"y":189.1434511336199}}' },
  { id: '2054020655219761154', deviceId: '2054007940505952258', config: '{"data":{"text":"1013房间墙侧间隔筒灯","x":1084.6170352406475,"y":190.1434511336199}}' },
  { id: '2054020665185427458', deviceId: '2054007940505952259', config: '{"data":{"text":"1013房间大灯","x":1176.1111074842688,"y":188.6434511336199}}' },
  { id: '2054020806218899458', deviceId: '2054007940505952260', config: '{"data":{"text":"1012房间墙侧间隔筒灯","x":815.3888866240463,"y":191.31082560349347}}' },
  { id: '2054020825298788353', deviceId: '2054007940505952261', config: '{"data":{"text":"1012房间墙侧间隔筒灯","x":1005.1043255751276,"y":189.64345113361992}}' },
  { id: '2054020926649950209', deviceId: '2054007940505952262', config: '{"data":{"text":"1012房间大灯","x":908.9019529658476,"y":189.8985942860694}}' },
  { id: '2054021051451465730', deviceId: '2054007940510146562', config: '{"data":{"text":"1011房间南侧灯","x":429.9273091801821,"y":179.74864475100293}}' },
  { id: '2054021072246824962', deviceId: '2054007940510146563', config: '{"data":{"text":"1011房间北侧灯","x":658.9757126015608,"y":181.49353603926514}}' },
  { id: '2054021096653479937', deviceId: '2054007940510146564', config: '{"data":{"text":"1009B房间间隔大灯","x":227.5822575808367,"y":93.87063036176177}}' },
  { id: '2054021111379681282', deviceId: '2054007940510146565', config: '{"data":{"text":"1009B房间间隔大灯","x":225.30597522594408,"y":258.6503939349427}}' },
  { id: '2054021226781761538', deviceId: '2054007940510146576', config: '{"data":{"text":"1006-2","x":423.2477506883014,"y":888.5265426669604}}' },
  { id: '2054021241507962881', deviceId: '2054007940510146577', config: '{"data":{"text":"1006-3","x":423.7477506883015,"y":961.742500546858}}' },
  { id: '2054021382545629186', deviceId: '2054007940510146571', config: '{"data":{"text":"1007房间墙侧筒灯","x":85.76223339949809,"y":855.9196770138728}}' }
]

function dev (id, name, deviceNo, on, uploadTime) {
  return {
    id,
    deviceName: name,
    alias: name,
    deviceNo,
    sn: deviceNo,
    addressName: '10F',
    dataPropertyList: on == null ? null : [{
      identifier: 'C',
      data: !!on,
      name: '开关控制'
    }],
    commonDeviceData: uploadTime ? { uploadTime } : null,
    lastUpdateTime: uploadTime || ''
  }
}

export const MOCK_DEVICE_GROUPS = [
  {
    deviceType: 6,
    deviceInfoList: [
      dev('2051888177138917377', '10楼东大字', 'LCB01', false, '2026-05-19 13:03:41'),
      dev('2051889474760105986', '10东电梯厅灯带', 'LCB02', false, '2026-05-19 13:03:41'),
      dev('2051889474768494593', '南过道', 'LCB03', false, '2026-05-19 13:03:41'),
      dev('2051889474768494594', '北过道＋小过道', 'LCB04', false, '2026-05-19 13:03:41'),
      dev('2054007940493369345', '1013房间墙侧间隔筒灯', '24e124782f501453-C1', null, null),
      dev('2054007940505952258', '1013房间墙侧间隔筒灯', '24e124782f501453-C2', null, null),
      dev('2054007940505952259', '1013房间大灯', '24e124782f501453-C3', null, null),
      dev('2054007940505952260', '1012房间墙侧间隔筒灯', '24e124782f501230-C1', false, '2026-05-19 12:53:47'),
      dev('2054007940505952261', '1012房间墙侧间隔筒灯', '24e124782f501230-C2', false, '2026-05-19 12:53:47'),
      dev('2054007940505952262', '1012房间大灯', '24e124782f501230-C3', false, '2026-05-19 12:53:47'),
      dev('2054007940510146562', '1011房间南侧灯', '24e124782f501392-C1', null, null),
      dev('2054007940510146563', '1011房间北侧灯', '24e124782f501392-C2', null, null),
      dev('2054007940510146564', '1009B房间间隔大灯', '24e124782f501837-C1', false, '2026-05-19 12:48:53'),
      dev('2054007940510146565', '1009B房间间隔大灯', '24e124782f501837-C2', false, '2026-05-19 12:48:53'),
      dev('2054007940510146566', '公共空间长条灯', '24e124782f501238-C1', false, '2026-05-19 12:54:35'),
      dev('2054007940510146567', '公共空间墙侧筒灯', '24e124782f501238-C3', false, '2026-05-19 12:54:35'),
      dev('2054007940510146568', '105B-1', '24e124782f501119-C1', null, null),
      dev('2054007940510146569', '105B-2', '24e124782f501119-C2', null, null),
      dev('2054007940510146570', '105B-3', '24e124782f501119-C3', null, null),
      dev('2054007940510146571', '1007房间墙侧筒灯', '24e124782f501942-C1', true, '2026-05-19 13:02:47'),
      dev('2054007940510146572', '1007房间办公区间隔灯', '24e124782f501942-C2', true, '2026-05-19 13:02:47'),
      dev('2054007940510146573', '1007房间办公区间隔灯', '24e124782f501367-C1', false, '2026-05-19 12:45:52'),
      dev('2054007940510146574', '1007房间公司牌灯', '24e124782f501367-C2', false, '2026-05-19 12:45:52'),
      dev('2054007940510146575', '1006-1', '24e124782f501540-C1', false, '2026-05-19 13:03:16'),
      dev('2054007940510146576', '1006-2', '24e124782f501540-C2', true, '2026-05-19 13:03:16'),
      dev('2054007940510146577', '1006-3', '24e124782f501540-C3', true, '2026-05-19 13:03:16')
    ]
  }
]
